import React from "react";
import { useEffect } from "react";
import { Auth } from "aws-amplify";
import { saveLogin } from "./utils";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import ShimmerDashboard from "./ShimmerDashboard";

const SSOLogin = (props) => {
  const history = useHistory();

  const processSSOToken = async () => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (!token) {
      props.history.push("/login");
      return;
    }

    try {
      await Auth.federatedSignIn(
        `cognito-idp.us-east-2.amazonaws.com/${process.env.REACT_APP_aws_user_pools_id}`,
        { token, expires_at: Date.now() + 3600 * 1000 },
        null
      );

      sessionStorage.setItem("sso_token", token);
      sessionStorage.setItem("switchToken", token);

      const decoded = JSON.parse(atob(token.split(".")[1] || ""));
      const email = decoded.email || decoded["cognito:username"] || "";

      sessionStorage.setItem("isLogged", "true");
      localStorage.setItem("IAgree", "true");
      saveLogin(email);

      window.history.replaceState({}, document.title, "/admin");
        props.setUserLogin(true);
        getToken();
      props.history.push("/admin");
    } catch (err) {
      console.error("SSO failed", err);
      props.history.push("/login");
    }
  };

    const getToken = () => {
        let request = {
            "username": process.env.REACT_APP_GETWAY_TOKEN_USERNAME,
            "password": process.env.REACT_APP_GETWAY_TOKEN_PASS
        }
        let innoOrganization = Buffer.from(`${process.env.REACT_APP_AMERICAN_COLLECTIVE};${new Date()}`).toString('base64')
        Axios.post(process.env.REACT_APP_BaseAPIURL + "api/v1/login", request, {
            headers: {
                'X-Tenant-Id': innoOrganization,
            }
        }).then(response => {
            if (response.data.message) {
                console.log("failed to get token")
                alert(response.data.message)
            }
            else {
                let bearer = response['headers'].authorization
                var array = bearer.split("Bearer ")
                localStorage.setItem("innobearerToken", array[1]);
            }
        })
    }

  useEffect(() => {
    processSSOToken();
  }, []);

    return <ShimmerDashboard />;
};

export default SSOLogin;
